<template>
  <div class="property_wrap">
    <div class="pro_top">企业资讯设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <!--<el-form-item label="组件标题:">-->
        <!--<el-input v-model="property.name" maxlength="10" show-word-limit></el-input>-->
        <!--</el-form-item>-->
        <el-table
                :data="tableList"
                style="width: 100%;margin-bottom:30px;">
          <el-table-column
                  prop="title"
                  label="资讯标题"
                  width="120">
          </el-table-column>
          <el-table-column
                  label="资讯封面">
            <template slot-scope="scope">
              <img :src="scope.row.pic" alt="" width="60" height="60">
            </template>
          </el-table-column>
          <el-table-column
                  prop="create_time"
                  label="发布时间"
                  width="100">
          </el-table-column>
          <el-table-column
                  label="状态">
            <template slot-scope="scope">
              <el-switch
                      @change="switchChange($event,scope.$index)"
                      v-model="scope.row.is_select_val"
                      active-color="#2AA3F8"
                      inactive-color="#ddd">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
                  label="操作"
                  width="170">
            <template slot-scope="scope">
              <el-button @click="addInfo(scope.$index)" size="small">编辑</el-button>
              <el-button @click="detelLineFn(scope.$index)" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="addInfo('add')" size="small">添加资讯</el-button>
      </el-form>
    </div>
    <!--    添加资讯-->
    <addInfomation :visible.sync="dialogVisible" :infomation="listDetail" @checkInt="checkInt"></addInfomation>
  </div>
</template>
<script>
  import api from '@/api.js';
  import addInfomation from "@/components/dialog/addInfomation.vue";

  export default {
    props: ["property"],
    components: {
      addInfomation
    },
    data() {
      return {
        listDetail: null,
        dialogVisible: false,
        from: {
          name: '',
          list: []
        },
        formLabelWidth: '80px',
        tableList: [],
        chooseId: [] // 选中id
      };
    },
    watch: {
      property: {
        immediate: true,
        handler(val) {
          this.from = val
        }
      }
    },
    mounted() {
      this.$emit('update:property', this.from)
    },
    created() {
      this.InitFn(1)
    },
    methods: {
      InitFn(option) {
        this.axios
            .post(api.information_index, {})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.list) {
                  if (response.data.list[i].is_select === 0) {
                    response.data.list[i].is_select_val = false
                  } else {
                    response.data.list[i].is_select_val = true
                  }
                  if (this.chooseId.indexOf(response.data.list[i].id) !== -1) {
                    response.data.list[i].is_select_val = true
                  }
                  if (option === 2 && this.listDetail.id === response.data.list[i].id) {
                    for (let j in this.from.list) {
                      if (this.from.list[j].id === this.listDetail.id) {
                        this.$set(this.from.list, j, response.data.list[i])
                        this.listDetail = null
                      }
                    }
                  }
                }
                this.tableList = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      checkInt(data) {
        for (let i in data) {
          data[i].is_select_val = data[i].is_select === 0 ? false : true
          if (this.chooseId.indexOf(data[i].id) !== -1) {
            data[i].is_select_val = true
          }
          if (this.listDetail != null && this.listDetail.id === data[i].id) {
            if (this.from.list.length > 0) {
              for (let j in this.from.list) {
                if (this.from.list[j].id === this.listDetail.id) {
                  this.$set(this.from.list, j, data[i])
                  this.listDetail = null
                }
              }
            }
          }
        }
        this.tableList = data 
      },
      // 选中取消
      switchChange(even, index) {
        if (even) {
          let listObj = this.tableList[index]
          delete listObj.content
          this.from.list.push(listObj)
          this.chooseId.push(this.tableList[index].id)
        } else {
          for (let i in this.from.list) {
            if (this.from.list[i].id === this.tableList[index].id) {
              this.from.list.splice(i, 1)
            }
          }
          this.chooseId.splice(this.chooseId.indexOf(this.tableList[index].id), 1)
        }
      },
      // 删除
      detelLineFn(index) {
        let self_ = this
        this.$confirm('该资讯信息将立即被删除，删除后无法恢复！是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          self_.axios
              .post(api.information_delete, {info_id: self_.tableList[index].id})
              .then(response => {
                if (response.data.code == 0) {
                  if (self_.tableList[index].is_select_val) {
                    for (let i in self_.from.list) {
                      if (self_.from.list[i].id === self_.tableList[index].id) {
                        self_.from.list.splice(i, 1)
                      }
                    }
                  }
                  self_.tableList.splice(index, 1)
                  self_.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {

        });
      },
      addInfo(option) {
        if (option!=='add') {
          this.axios
              .post(api.information_detail, {fre_id: this.tableList[option].id})
              .then(response => {
                if (response.data.code == 0) {
                  this.listDetail = response.data.info;  
                  this.dialogVisible = true;
                }
              })
              .catch(response => {

              })
          // this.listDetail = this.tableList[option]
        }else{
          this.listDetail = null
          this.dialogVisible = true
        } 
      }
    }
  };
</script>
<style>
  .avatar-uploader-icon {
    width: 150px;
    height: 150px;
    line-height: 150px;
  }
</style>
